// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3WCs8","image":"Header_image__Al5q0","name":"Header_name__3cuCv","info":"Header_info__26MPg","infoRow":"Header_infoRow__vZHsQ"};